module.exports = __webpack_public_path__ + "media/images/LearnMore22-15fa760b1e585856d18dfaf309802733.png";